export enum FormNames {
  Hero = "hero",
  AtAGlance = "atAGlance",
  OurServices = "ourServices",
  AboutUs = "aboutUs",
}
